import axios from "axios";

const ML_BASE_URL = "https://sensores.iseq.com.br/ml/";
console.log("ML BASE URL:", ML_BASE_URL);

const mlApi = axios.create({
  baseURL: ML_BASE_URL,
  timeout: 120000,
});

export const analyzeML = (payload) => mlApi.post("analyze", payload);
export const getMLParametros = () => mlApi.get("parametros");

export default mlApi;

